<template>
  <div class="box6">
    <div class="blockone" ref="block"></div>
    <pageTitle
      title="更扎实的基础知识+更全面的进阶技能<br />助你职位发展先人一步"
      text="在这里你学会的是编程，不仅仅是C++这门语言！"
    />

    <div class="content">
      <div
        class="subject-box"
        v-for="(item, index) in list"
        :key="index"
        ref="item"
      >
        <div class="subject" @click="changeCur(index)">
          <div class="tag">{{ item.stage }}</div>
          <div class="title">{{ item.title }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          class="course-content"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>

          <div class="title-icon">
            <img
              class="icon1"
              src="../../../assets/coursePage/cPuls/box6/icon1.png"
              alt
            />主要知识点
          </div>

          <div class="main-text ability">
            <p v-for="j in item.knowledge" :key="j + 'a'">{{ j }}</p>
          </div>

          <div class="title-icon">
            <img
              class="icon2"
              src="../../../assets/coursePage/cPuls/box6/icon2.png"
              alt
            />学后可掌握的核心能力
          </div>

          <div class="main-text ability">
            <p v-for="i in item.ability" :key="i + 'b'">{{ i }}</p>
          </div>

          <div class="title-icon">
            <img
              class="icon3"
              src="../../../assets/coursePage/cPuls/box6/icon3.png"
              alt
            />学后可解决的现实问题
          </div>

          <div class="main-text ability">
            <p v-for="k in item.problem" :key="k + 'd'">{{ k }}</p>
          </div>

          <div class="title-icon">
            <img
              class="icon4"
              src="../../../assets/coursePage/cPuls/box6/icon4.png"
              alt
            />学习成就
          </div>

          <div class="main-text ability">
            <p v-for="h in item.achievement" :key="h + 'd'">{{ h }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="btn" @click="openDetail">查看更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          stage: "阶段一",
          title: "C开发实战",

          knowledge: [
            "C语言概述",
            "编程基础",
            "函数",
            "指针",
            "内存管理",
            "复合类型",
            "文件操作",
            "案例实战",
          ],
          ability: [
            "培养编程思维和动手能力；",
            "培养面向过程编程思想，为以后的深入学习打下坚实基础。",
          ],
          problem: [
            "具备C/C++领域基础专业编程能力；",
            "能够实现电子词典项目案例；",
            "能够实现贪吃蛇项目案例。",
          ],
          achievement: [
            "全国计算机二级考试（80分以上水平）；",
            "入门计算机开发编程领域；",
            "达到一本以上大学高校《C语言课程设计》、《C语言期末考试》能力。",
          ],
        },

        {
          stage: "阶段二",
          title: "C高级编程",
          knowledge: [
            "内存分区、函数调用模型",
            "指针高级",
            "函数指针与回调函数",
            "数据结构与链表",
            "递归函数",
            "数据结构与算法",
            "接口的封装和设计",
          ],
          ability: [
            "掌握C语言中的字符串、一维数组、二维数组的用法；",
            "掌握一级指针、二级指针、三级指针的高级用法，并理解N级指针概念，指针数组和数组指针；",
            "学会结构体、文件的使用；",
            "掌握C语言接口封装设计。",
          ],
          problem: [
            "可独立开发小程序，例如贪吃蛇；",
            "能够应用C语言接口封装设计的方法，进行企业项目开发。",
          ],
          achievement: [
            "高于一般本科院校计算机相关专业应届生的编程水平；",
            "达到1年传统企业（二线、三线、四线城市居多）C语言工程师编程能力；",
            "达到全国计算机等级考试四级水平。",
          ],
        },

        {
          stage: "阶段三",
          title: "C++核心编程和桌面应用开发",
          knowledge: [
            "C++对C的扩展、引用",
            "函数重载",
            "类和对象",
            "对象的动态分配和释放",
            "运算符重载",
            "类的继承和派生、多态",
            "面向抽象类编程",
            "函数模板、类模板",
            "异常、I/O流",
            "STL",
            "Qt常用的控件",
            "Qt绘图与文件操作",
            "Qt界面编程实战案例",
          ],
          ability: [
            "具备常用C++方向基本知识与常用技能；",
            "具备常用Qt和MFC界面开发的基本技巧和常用技能。",
          ],
          problem: [
            "具备基本开发能力：看懂简单代码，能够开发简单程序软件的功能；",
            "能够实现简单的前台界面开发。",
          ],
          achievement: [
            "PC端桌面应用程序开发能力；",
            "1-3年PC端应用编程岗位任职能力；",
            "具备面向对象编程能力。",
          ],
        },

        {
          stage: "阶段四",
          title: "Linux高并发服务器开发",
          knowledge: [
            "Linux命令",
            "Linux开发与调试工具",
            "系统I/O操作",
            "进程与IPC通信",
            "线程与并发同步",
            "信号",
            "网络协议与网络编程",
            "高并发服务器开发",
          ],
          ability: [
            "具备常用后台服务器开发方向的基本知识和常用技能，并具备基本开发能力。",
          ],
          problem: ["可完成服务器后台、前端界面、服务器数据库的开发。"],
          achievement: [
            "达到1-3年Linux服务器开发工程师水平；",
            "具备Linux系统运维能力；",
            "具备互联网公司高并发服务器设计能力。",
          ],
        },

        {
          stage: "阶段五",
          title: "Windows/Linux跨平台企业项目",
          knowledge: [
            "Oracle",
            "MySQL",
            "企业财富库的接口的封装和设计",
            "Windows经典应用程序开发",
            "Linux经典应用程序开发",
            "跨平台兼容开发与调试",
            "Git代码管理",
            "大项目：跨平台企业项目",
          ],
          ability: ["掌握常用数据库类型的操作技巧和简单开发能力。"],
          problem: [
            "能够熟练应用项目中使用的数据库知识，完成简单的数据库开发。",
          ],
          achievement: [
            "具备计算机安全技术能力；",
            "具备企业级安全研发工程师任职能力。",
          ],
        },

        {
          stage: "阶段六",
          title: "游戏服务器开发",
          knowledge: [
            "zinx框架使用",
            "游戏业务实现",
            "3inx抽象框架实现",
            "商业化部署",
          ],
          ability: [
            "能够采用高性能、分式式解决方案，统一游戏或其他应用后端云平台。",
          ],
          problem: ["具备分布式开发能力；", "具备游戏核心开发能力。"],
          achievement: ["满足游戏公司对服务器开发工程师的能力要求。"],
        },

        {
          stage: "阶段七",
          title: "Shell脚本编程",
          knowledge: ["Shell脚本编程"],
          ability: [
            "Unix/Linux下Shell编程开发；",
            "掌握Shell的函数语法和工具制作；",
            "掌握Linux常用Shell指令和问题定位方法。",
          ],
          problem: ["复习和巩固所学知识，为就业做准备。"],
          achievement: ["达到Linux运维工程师能力水平。"],
        },

        {
          stage: "阶段八",
          title: "Go语言微服务项目",
          knowledge: [
            "Go语言语法",
            "微服务开发",
            "大项目：微服务应用开发",
            "Docker操作",
          ],
          ability: [
            "具备Go语言高并发后台开发能力；",
            "拥有Docker虚拟化容器技术；",
            "具备分布式微服务架构设计能力。",
          ],
          problem: ["实现企业资源利用率和可用性的优化。"],
          achievement: [
            "可满足市场对Go中级程序员的需求，可独立设计开发微服务项目。",
          ],
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("C/C++-就业课","查看更多",0,null)
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 0px 0px 88px;
  width: 100%;
  background: linear-gradient(180deg, #f6fbfe 0%, #e8f6ff 100%);
  overflow: hidden;
  .blockone {
    height: 80px;
  }
  .content {
    margin-top: 60px;
  }

  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 96px;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    line-height: 96px;
    text-align: center;
    letter-spacing: 2px;
    color: #ffffff;

    background-image: linear-gradient(-5deg, #4085ff 0%, #33bbff 100%);
    border-radius: 48px;
  }

  .title-top {
    position: relative;
    margin: 60px auto 0;
    margin-bottom: 40px;
    padding-left: 50px;
    width: 690px;
    height: 100px;
    background: url("../../../assets/coursePage/pythonData/box9/title.png")
      no-repeat;
    background-size: cover;
    border-radius: 20px;
    box-shadow: 0px 6px 29px 0px rgba(135, 212, 240, 0.98);
    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    line-height: 100px;
    letter-spacing: 0px;
    color: #ffffff;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 100px;
      letter-spacing: 0px;
      color: #ffffff;
      text-shadow: 6px 16px 0px #3f6ae4;
    }
    &::after {
      position: absolute;
      right: 0px;
      bottom: 0px;
      content: "";
      width: 180px;
      height: 126px;
      background: url("../../../assets/coursePage/pythonData/box9/icon.png")
        no-repeat;
      background-size: cover;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
    background: #ffffff;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 28px 32px;
    border-radius: 16px;

    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;

    .tag {
      width: 96px;
      height: 40px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 8px;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 700;
      color: #4080ff;
      line-height: 40px;
      box-sizing: border-box;
    }
    .tag2 {
      color: rgb(35, 195, 182);
    }
    .title {
      margin-left: 24px;
      margin-right: 20px;
      width: 472px;
      font-size: 28px;
      font-weight: 700;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease;
    overflow: hidden;
    z-index: 3;
    overflow-y: scroll;
    border-radius: 0 0 16px 16px;
    .line {
      margin-bottom: 32px;
      width: 622px;
      height: 1px;
      background: #f2f3f5;
      margin-left: -8px;
    }
  }

  .show-answer {
    padding: 0px 40px;
    padding-bottom: 20px;
    // display: block;
    max-height: 3900px;
    opacity: 1;
    transition: max-height 0.4s ease;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
      background-size: contain;
    }
  }
  .special-title-icon {
    margin-bottom: 16px;
  }
  .main-content {
    margin-bottom: 28px;
    margin-left: 45px;
    .main-content-title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .main-content-item {
      display: flex;
      flex-wrap: wrap;
      span {
        display: inline-block;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
      i {
        margin-left: -4px;
      }
    }
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 20px;

      border-radius: 8px;

      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      display: flex;
      align-items: center;

      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
    }
  }

  .main-text {
    margin-bottom: 48px;
    p {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-left: 45px;
      i {
        display: none;
        width: 4px;
        height: 4px;
        background: #87d4bd;
        border-radius: 2px;
        margin-right: 16px;
      }
    }
  }
  .ability {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
}
</style>
